import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import { BodyMedium, ButtonLink, DivWithShadow, H4, LabelSmall, LinkSmall } from '@styled';
import { mediaQueries } from '@general/breakpoints';

const NavContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;

    @media ${mediaQueries.md} {
        display: block;
        margin-top: 0;
    }

    span,
    a {
        line-height: 14px;
    }
`;

const TipsWindow = ({ ...props }) => {
    const { title, tips } = props;
    const [showTips, setShowTips] = useState(true);
    const [displayTip, setDisplayTip] = useState(0);

    return (
        <>
            {showTips && (
                <DivWithShadow className="p-3 my-4">
                    <button
                        type="button"
                        className="close text-black"
                        aria-label="Close"
                        onClick={() => setShowTips(false)}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>

                    <LabelSmall className="mb-0.5rem">{title}</LabelSmall>

                    {tips.map((tip, index) => (
                        <div key={`tip${index}`} className={index === displayTip ? 'd-block' : 'd-none'}>
                            <H4 className="font-weight-bold mb-0.5rem">{tip.title}</H4>
                            <BodyMedium className="mb-1.5rem">{tip.message}</BodyMedium>

                            <div className="d-md-flex justify-content-between align-items-end">
                                <div>
                                    <ButtonLink href={tip.cta.link} className="px-5">
                                        {tip.cta.name}
                                    </ButtonLink>
                                </div>

                                <NavContainer>
                                    {index === 0 ? (
                                        <LabelSmall className="mr-0.75rem text-background">&lt; Previous</LabelSmall>
                                    ) : (
                                        <LinkSmall
                                            href="#"
                                            onClick={() => setDisplayTip(index - 1)}
                                            className="mr-0.75rem text-decoration-none"
                                        >
                                            <LabelSmall className="text-primary">&lt; Previous</LabelSmall>
                                        </LinkSmall>
                                    )}

                                    {index === tips.length - 1 ? (
                                        <LabelSmall className="text-background">Next &gt;</LabelSmall>
                                    ) : (
                                        <LinkSmall
                                            href="#"
                                            onClick={() => setDisplayTip(index + 1)}
                                            className="text-decoration-none"
                                        >
                                            <LabelSmall className="text-primary">Next &gt;</LabelSmall>
                                        </LinkSmall>
                                    )}
                                </NavContainer>
                            </div>
                        </div>
                    ))}
                </DivWithShadow>
            )}
        </>
    );
};

TipsWindow.propTypes = {
    title: PropTypes.string,
    tips: PropTypes.array,
};

export default TipsWindow;
